<template>
  <div style="margin: 10px 0px 20px;">
    <el-upload
      :action="importUrl"
      :headers="headers"
      :before-upload="beforeAvatarUpload"
      :before-remove="beforeRemove"
      :on-success="handleAvatarSuccess"
      :on-remove="handleRemove"
      :file-list="currentValue"
      :on-error="uploadError"
      :disabled="isAbled"
      :on-progress="progressing"
      v-if="visible"
    >
      <el-button size="small" type="primary">导入附件</el-button>
      <div slot="tip" class="el-upload__tip" v-if="!type">
        <strong style="margin-right: 5px; line-height: 20px;">附件说明：</strong
        >导入附件，该功能主要支持三天下的操作页面上的附件文件导入上传功能，实现从教学平台获取附件导入三天下效果。目前不支持仿真政务等其他导入功能。
      </div>
    </el-upload>
  </div>
</template>
<script>
import * as api from "../api/courseApi";
export default {
  name: "v_addFile",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: true,
    },
    isUploading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentValue: this.value,
      importUrl: "", // 上传各种文件的服务器地址
      fileType: "",
      successUpdateParams: {},
      isAbled: false,
    };
  },
  created() {},
  computed: {
    headers() {
      return {
        Authorization: "bearer " + localStorage.getItem("Authorization"),
      };
    },
  },
  watch: {
    value(val) {
      if (val){
        this.currentValue = val;
      }else{
        this.currentValue = [];
      }

    },
    currentValue(newV) {
      this.$emit("input", newV);
    },
  },
  methods: {
    //添加素材上传 准备参数
    beforeAvatarUpload(file) {
      let fileSize = file.size;
      let name = file.name;
      if (name.length > 200) {
        this.$message.warning("名字长度过长,请重新选择");
        this.isAbled = false;
        return;
      }
      this.loading = true;
      let suffix = name.substring(name.lastIndexOf(".") + 1);
          console.log('-------------', suffix);
      let docArr = [
        "docx",
        "DOCX",
        "doc",
        "DOC",
        "ppt",
        "PPT",
        "pptx",
        "PPTX",
        "pdf",
        "PDF",
        "xlsx",
        "xls",
        "XLSX",
        "XLS",
        "TXT",
        "txt"
      ];
      if (docArr.indexOf(suffix) != -1) {
        if (fileSize > 104857600) {
          //104857600 100M
          this.$message.warning("上传文件不能大于100M");
          this.isAbled = false;
          return;
        }
        //上传类型 2 文档
        this.fileType = 2;
        this.isAbled = true;
        return new Promise((resolve) => {
          this.$nextTick(() => {
            this.importUrl = `${process.env.UPLOAD_NAME}/file/uploadDocument`;
            resolve();
          });
        });
      } else if (
        suffix == "mp4" ||
        suffix == "MP4" ||
        suffix == "avi" ||
        suffix == "AVI" ||
        suffix == "asx" ||
        suffix == "ASX" ||
        suffix == "asf" ||
        suffix == "ASF" ||
        suffix == "mpg" ||
        suffix == "MPG" ||
        suffix == "3gp" ||
        suffix == "3GP" ||
        suffix == "mov" ||
        suffix == "MOV" ||
        suffix == "avi" ||
        suffix == "AVI" ||
        suffix == "flv" ||
        suffix == "FLV"
      ) {
        if (fileSize > 2147483648) {
          //2147483648 2G
          this.$message.warning("上传视频文件不能大于2G");
          this.isAbled = false;
          return;
        }
        //上传类型 4  视频
        this.fileType = 4;
        this.isAbled = true;
        return new Promise((resolve) => {
          this.$nextTick(() => {
            this.importUrl = `${process.env.UPLOAD_NAME}/file/uploadVideo`;
            resolve();
          });
        });
        // return true;
      } else if (suffix == "mp3") {
        if (fileSize > 31457280) {
          //31457280 2G
          this.$message.warning("上传音频文件不能大于30M");
          this.isAbled = false;
          return;
        }
        //上传类型 3  音频
        this.fileType = 3;
        this.isAbled = true;
        return new Promise((resolve) => {
          this.$nextTick(() => {
            this.importUrl = `${process.env.UPLOAD_NAME}/file/uploadAudio`;
            resolve();
          });
        });
      } else if (suffix == "jpg" || suffix == "png" || suffix == "jpeg") {
        if (fileSize > 10485760) {
          //104857600 10M
          this.$message.warning("上传图片不能大于10M");
          this.isAbled = false;
          return;
        }
        //上传类型 1  图片
        this.fileType = 1;
        this.isAbled = true;
        return new Promise((resolve) => {
          this.$nextTick(() => {
            this.importUrl = `${process.env.UPLOAD_NAME}/file/uploadImage`;
            resolve();
          });
        });
      } else if (suffix == "zip") {
        if (fileSize > 104857600) {
          //104857600 100M
          this.$message.warning("上传压缩包不能大于100M");
          this.isAbled = false;
          return;
        }
        this.fileType = 5;
        this.isAbled = true;
        // this.materialForm.upload.data.savepath = "course_res_/resourse/";
        return new Promise((resolve) => {
          this.$nextTick(() => {
            this.importUrl = `${process.env.UPLOAD_NAME}/file/uploadZip`;
            resolve();
          });
        });
      } else {
        this.$message.error("上传文件格式错误");
        this.isAbled = false;
        return false;
      }
    },
    progressing() {
      this.$emit("changeUploadStatus", true);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file) {
      if (this.type){  //事项中调用组件。直接删除
        this.currentValue.splice(this.currentValue.indexOf(file), 1);
      }else{
        let id = "";
        if (file.response) {
          id = file.response.data.attachmentId;
        } else {
          id = file.id;
        }
        // let params = {
        //   attachmentId: id,
        //   questionId: parseInt(this.$route.query.id),
        // };
        api.DeleteAttachment({
          attachmentId: id,
          // questionId: parseInt(sessionStorage.getItem('addTestSubjectId')),
          questionId: '',
        }).then((res) => {
          if (res.code == 0) {
            this.$message({ message: "删除成功！", type: "success" });
            this.currentValue.splice(this.currentValue.indexOf(file), 1);
          } else {
            this.$message.error(res.msg)
          }
        })
          .catch((error) => {
            console.log(error);
          });
      }

    },
    // 删除文件之前的钩子
    beforeRemove(file) {
      // console.log(file);
      return this.$confirm(`确定移除 "${file.name}"？`);
    },
    // 文件上传成功时的钩子
    handleAvatarSuccess(res) {
      // 保存ids
      // this.currentValue.push(res.data.attachmentId);
      switch (this.fileType) {
        case 1: //图片
          this.successUpdateParams = {
            id: res.data.attachmentId,
            operateFlag: 1,
            name: res.data.name,
            newAttaUrl: res.data.imagePath,
            originalAttaUrl: res.data.imagePath,
            size: res.data.imageSize,
            type: res.data.type,
            typeSuffix: res.data.typeSuffix,
            cover: res.data.cover,
          };
          this.isAbled = false;
          this.$emit("changeUploadStatus", false);
          break;
        case 2: //文档
          this.successUpdateParams = {
            id: res.data.attachmentId,
            downloadFlag: 1,
            name: res.data.uploadnName,
            operateFlag: 1,
            newAttaUrl: res.data.pdfPath,
            originalAttaUrl: res.data.oldFilePath,
            size: res.data.size,
            type: res.data.docType,
            typeSuffix: res.data.docTypeSuffix,
            cover: res.data.cover,
          };
          this.isAbled = false;
          this.$emit("changeUploadStatus", false);
          break;
        case 3: //音频
          this.successUpdateParams = {
            id: res.data.attachmentId,
            downloadFlag: 1,
            operateFlag: 1,
            name: res.data.name,
            newAttaUrl: res.data.audioPath,
            originalAttaUrl: res.data.audioPath,
            size: res.data.size,
            type: res.data.type,
            typeSuffix: res.data.typeSuffix,
            cover: res.data.cover,
          };
          this.isAbled = false;
          this.$emit("changeUploadStatus", false);
          break;
        case 4: //视频
          this.successUpdateParams = {
            id: res.data.attachmentId,
            downloadFlag: 1,
            operateFlag: 1,
            name: res.data.name,
            newAttaUrl: res.data.realSuperPath,
            originalAttaUrl: res.data.oldFilePath,
            size: res.data.size,
            type: res.data.type,
            typeSuffix: res.data.typeSuffix,
            cover: res.data.cover,
          };
          this.isAbled = false;
          this.$emit("changeUploadStatus", false);
          break;
        case 5: //zip
          this.successUpdateParams = {
            id: res.data.attachmentId,
            name: res.data.name,
            type: res.data.type,
            typeSuffix: res.data.typeSuffix,
            originalAttaUrl: res.data.originalAttaUrl,
            newAttaUrl: res.data.newAttaUrl,
            size: res.data.size,
            cover: res.data.cover,
            operateFlag: 1,
          };
          this.isAbled = false;
          this.$emit("changeUploadStatus", false);
          break;
      }

      this.currentValue.push(this.successUpdateParams);
    },
    uploadError(err) {
      console.log(err);
    },
  },
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/v_addFile.vue